<script setup lang="ts">
/**
 * CaProsa — pembungkus teks panjang (halaman kebijakan & uraian SEO), tema v3.
 *
 * Kenapa komponen dengan <style scoped>, bukan menumpuk utility Tailwind di
 * tiap <p> dan <li>: halaman kebijakan punya ratusan elemen teks. Menempelkan
 * enam utility di masing-masingnya membuat halaman mustahil dibaca saat
 * disunting, dan satu elemen yang terlewat langsung terlihat sumbang.
 *
 * Gaya di sini SENGAJA memakai token `--ca-*` milik v3.css, bukan warna mentah,
 * sehingga mode gelap ikut benar tanpa aturan tambahan. Karena scoped + :deep(),
 * aturan ini tidak bisa bocor ke halaman lama di /legacy.
 *
 * Isi slot hanyalah teks: <p>, <ul>, <ol>, <li>, <strong>, <h3>, dan tautan.
 * Kontrol interaktif (tombol, input) TIDAK BOLEH diletakkan di sini — pakai
 * komponen Ca* di luar blok prosa.
 */
</script>

<template>
  <div class="ca-prosa">
    <slot />
  </div>
</template>

<style scoped>
.ca-prosa {
  color: var(--ca-text);
  font-size: 1rem;
  line-height: 1.75;
}

.ca-prosa :deep(p) {
  margin: 0 0 0.9rem;
}

.ca-prosa :deep(p:last-child) {
  margin-bottom: 0;
}

.ca-prosa :deep(h3) {
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.4;
  margin: 1.5rem 0 0.5rem;
  color: var(--ca-text);
}

.ca-prosa :deep(ul),
.ca-prosa :deep(ol) {
  margin: 0 0 0.9rem;
  padding-inline-start: 1.35rem;
}

.ca-prosa :deep(ul) {
  list-style: disc;
}

.ca-prosa :deep(ol) {
  list-style: decimal;
}

.ca-prosa :deep(li) {
  margin-bottom: 0.55rem;
}

.ca-prosa :deep(li::marker) {
  color: var(--ca-muted);
}

.ca-prosa :deep(strong) {
  font-weight: 700;
  color: var(--ca-text);
}

.ca-prosa :deep(a) {
  color: var(--ca-primary);
  font-weight: 600;
  text-decoration: underline;
  text-underline-offset: 2px;
}

.ca-prosa :deep(code) {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 0.875em;
  background: var(--ca-surface-2);
  border: 1px solid var(--ca-line);
  border-radius: 6px;
  padding: 0.1em 0.35em;
}
</style>
